import { GET_INTERNATIONAL_CUSTOMER_REQUEST, GET_INTERNATIONAL_CUSTOMER_SUCCESS, GET_INTERNATIONAL_CUSTOMER_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalCustomer = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_CUSTOMER_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalCustomer`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_CUSTOMER_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_CUSTOMER_ERROR,
                payload: error.response,
            });
        })
}

